/* unplugin-vue-components disabled */import { render } from "./EachSideShow.vue?vue&type=template&id=d147a072"
import script from "./EachSideShow.vue?vue&type=script&lang=js"
export * from "./EachSideShow.vue?vue&type=script&lang=js"

import "./EachSideShow.vue?vue&type=style&index=0&id=d147a072&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__